import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {PortfolioAccount} from 'src/app/domain/model/portfolio/portfolio-account.model';

export interface PortfolioAccountState {
  accounts: PortfolioAccount[];
}

const emptyState = () => ({
  accounts: [],
});

@Injectable({
  providedIn: 'root',
})
export default class PortfolioAccountStore extends ComponentStore<PortfolioAccountState> {
  public readonly accounts$ = this.select(state => Object.values(state.accounts));

  constructor() {
    super(emptyState());
  }

  saveAll(accounts: PortfolioAccount[]): void {
    this.patchState(() => ({
      accounts
    }));
  }

  syncAll(): PortfolioAccount[] {
    const accounts = this.get().accounts;
    if (!accounts) {
      return [];
    }
    return Object.values(this.get().accounts);
  }

  reset(): void {
    this.setState(() => (emptyState()));
  }
}
